/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Mutation = {
  __typename?: 'Mutation';
  registerHive: MutationResponse;
};


export type MutationRegisterHiveArgs = {
  input: RegisterHiveInput;
};

export type MutationError = {
  __typename?: 'MutationError';
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  viewHives: Array<ViewHivesView>;
};

export type RegisterHiveInput = {
  apiaryName: Scalars['String']['input'];
  colonyStrain: Scalars['String']['input'];
  hiveId: Scalars['String']['input'];
  hiveNumber: Scalars['String']['input'];
  queenYear: Scalars['Float']['input'];
};

export type ViewHivesView = {
  __typename?: 'ViewHivesView';
  apiaryName?: Maybe<Scalars['String']['output']>;
  colonyStrain?: Maybe<Scalars['String']['output']>;
  hiveId: Scalars['String']['output'];
  hiveNumber?: Maybe<Scalars['String']['output']>;
  queenYear?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ViewHivesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewHivesQueryQuery = { __typename?: 'Query', viewHives: Array<{ __typename: 'ViewHivesView', hiveId: string, apiaryName?: string | null, hiveNumber?: string | null, queenYear?: number | null, colonyStrain?: string | null, url?: string | null }> };

export type RegisterHiveMutationMutationVariables = Exact<{
  input: RegisterHiveInput;
}>;


export type RegisterHiveMutationMutation = { __typename?: 'Mutation', registerHive: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };


export const ViewHivesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewHivesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewHives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"hiveId"}},{"kind":"Field","name":{"kind":"Name","value":"apiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"hiveNumber"}},{"kind":"Field","name":{"kind":"Name","value":"queenYear"}},{"kind":"Field","name":{"kind":"Name","value":"colonyStrain"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ViewHivesQueryQuery, ViewHivesQueryQueryVariables>;
export const RegisterHiveMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterHiveMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterHiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerHive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RegisterHiveMutationMutation, RegisterHiveMutationMutationVariables>;